import { App, Component } from "vue";
import BooleanFieldFilter from "./Pc/FilterItems/BooleanFieldFilter.vue";
import DateFieldFilter from "./Pc/FilterItems/DateFieldFilter.vue";
import DepartFieldFilter from "./Pc/FilterItems/DepartFieldFilter.vue";
import MultChoiceProFieldFilter from "./Pc/FilterItems/MultChoiceProFieldFilter.vue";
import MultTextFieldFilter from "./Pc/FilterItems/MultTextFieldFilter.vue";
import NumericFieldFilter from "./Pc/FilterItems/NumericFieldFilter.vue";
import PositionFieldFilter from "./Pc/FilterItems/PositionFieldFilter.vue";
import SingleChoiceProFieldFilter from "./Pc/FilterItems/SingleChoiceProFieldFilter.vue";
import SingleDepartFieldFilter from './Pc/FilterItems/SingleDepartFieldFilter.vue';
import SingleUserFieldFilter from './Pc/FilterItems/SingleUserFieldFilter.vue';
import TextFieldFilter from "./Pc/FilterItems/TextFieldFilter.vue";
import UserFieldFilter from './Pc/FilterItems/UserFieldFilter.vue';

let components = [
    BooleanFieldFilter,
    DateFieldFilter,
    DepartFieldFilter,
    MultChoiceProFieldFilter,

    MultTextFieldFilter,
    NumericFieldFilter,
    PositionFieldFilter,
    SingleChoiceProFieldFilter,
    SingleDepartFieldFilter,
    SingleUserFieldFilter,
    TextFieldFilter,
    UserFieldFilter,
]

export default function useFields(app: App) {
    // 注册组件
    components.forEach((component: Component) => {
       app.component(component.name ?? "", component);
    });

    app.component("PrimaryKeyFieldFilter", TextFieldFilter);
}